<template>
    <div>
        <div class="modal fade" id="downPaymentEventModal" tabindex="-1" aria-labelledby="downPaymentEventModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-md modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 id="downPaymentEventModalLabel" class="font-weight-bold">Add Uang Muka</h4>
                        <a type="button" data-bs-dismiss="modal" aria-label="Close">
                            <i class="fa fa-times"></i>
                        </a>
                    </div>

                    <div class="modal-body">
                        <CRow class="pb-3">
                            <div class="col-5">
                                <label class="form-label font-weight-bold required">Uang Muka</label>
                                <label class="form-label font-weight-bold" style="float:right">:&nbsp;</label>
                            </div>
                            <div class="col-7">
                                <input type="number" id="DownPayment" v-model="DownPayment" class="font-weight-bold form-control input-number" min="0"/>
                                <label id="errorDownPayment" class="form-error" style="display: none; color: red;"></label>
                            </div>                                
                        </CRow>
                        <CRow class="pb-3">
                            <CCol sm="5">
                                <label class="form-label font-weight-bold required">Tanggal</label>
                                <label class="form-label font-weight-bold" style="float:right">:&nbsp;</label>
                            </CCol>
                            <CCol sm="7">
                                <date-picker
                                    v-model="DownPaymentDate"
                                    format="DD MMM YYYY"
                                    type="date"
                                    placeholder="Select date"
                                    value-type="YYYY-MM-DD"
                                    style="width:100%"
                                ></date-picker>
                                <label id="errorDownPaymentDate" class="form-error" style="display: none; color: red;"></label>
                            </CCol>                                    
                        </CRow>
                        <CRow>
                            <CCol sm="5">
                                <label class="form-label font-weight-bold required">Catatan</label>
                                <label class="form-label font-weight-bold" style="float:right">:&nbsp;</label>
                            </CCol>
                            <CCol sm="7">
                                <CInput id="DownPaymentNote" v-model="DownPaymentNote" class="font-weight-bold"/>
                                <label id="errorDownPaymentNote" class="form-error" style="display: none; color: red;"></label>
                            </CCol>                                    
                        </CRow>
                       
                        <CButton type="button" @click="saveClick()" id="saveButton" color="success" style="float: right;"> Save </CButton>
                        <label style="float: right;">&nbsp;&nbsp;</label>
                        <CButton type="button" color="secondary" style="float: right;" data-bs-dismiss="modal" aria-label="Close"> Close </CButton>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import invoiceDownPaymentService from '../Script/InvoiceDownPaymentScript';
import datePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import { response } from '../../../../infrastructure/constant/response';
import { globalfunc } from '../../../../shared/GlobalFunction.js';

export default {
    name: 'DownPaymentEventForm',
    components: {
        'date-picker' : datePicker,
    },
    props: ['saveDownPaymentGrid'],
    mounted:  function () {
    },
    data: function () {
        return {
            DownPaymentId: '',
            DownPayment: 0,
            DownPaymentDate: '',
            DownPaymentNote: '',
            TotalGross: 0,
            TotalDownPayment: 0,
        }
    },
    methods: {
        async addClick(downPaymentId, totalGross, totalDownPayment){ 
            this.DownPaymentId = downPaymentId;
            this.DownPayment = 0;
            this.DownPaymentDate = '';
            this.DownPaymentNote = '';
            this.TotalGross = totalGross;
            this.TotalDownPayment = totalDownPayment;

            window.$('#downPaymentEventModal').modal('show');
        },
        errorShow(errorCode, message){
            document.getElementById(errorCode).style.display = 'block';
            document.getElementById(errorCode).innerHTML = message == undefined ? response.fieldRequired : message;
            this.Error++;
        },
        inputValidation(){
            this.Error = 0;
            $(".form-error").css("display", "none");

            //Validation
            if (this.DownPayment === '' || this.DownPayment == null) {
                this.errorShow('errorDownPayment');
            }
            else {
                var grandTotalDownPayment = parseInt(this.TotalDownPayment) + parseInt(this.DownPayment);
                if (grandTotalDownPayment > parseInt(this.TotalGross)) {
                    this.$swal("Error", "Total Uang Muka tidak boleh melebihi Total Gross", "error");
                    this.Error++;
                }
            }
            if(this.DownPaymentDate == '' || this.DownPaymentDate == null){
                this.errorShow('errorDownPaymentDate');
            }
        },
        saveClick(){
            this.inputValidation();

            //Proses
            if(this.Error == 0){
                this.$loading(true);

                const downPaymentData = {
                    down_payment_id: this.DownPaymentId,
                    date: this.DownPaymentDate,
                    amount: this.DownPayment,
                    notes: this.DownPaymentNote
                }

                const downPaymentVariables = {
                    data : downPaymentData
                }

                invoiceDownPaymentService.addEventQuery(downPaymentVariables).then(res => {
                    this.$loading(false);
                    this.$swal("Info", response.successSave, "success")
                        .then(res => {
                            if(res.isConfirmed == true || res.isDismissed == true){
                                window.location.reload();
                            }
                        });
                }).catch(error => {
                    this.$loading(false);
                    var errorMessage = globalfunc.errorExtractor(error)
                    this.$swal("Error", errorMessage, "error");
                });
            }
        }
    }
}
</script>

<style scoped>
.modal-xl-custom {
    max-width: 1500px;
}
</style>